import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';

import LockSVG from '~/assets/svgs/lock.svg';

const SafeEnvironment: React.FC = () => {
  return (
    <View className="flex-row items-center py-2 px-4 border-2 rounded bg-success-200 border-success-600">
      <LockSVG />

      <Text className="text-[9px] text-success-900 pl-4">
        Você está em um ambiente seguro. Dados criptografados.
      </Text>
    </View>
  );
};

export default SafeEnvironment;
